import React from 'react';
import classNames from 'classnames';
import { SIZES, APPEARANCES, POSITION } from './constants';
import Icon from '../icon';
// eslint-disable-next-line yola/@typescript-eslint/no-unused-vars
import { iconsList } from '../icon/glyphs';

// @ts-ignore TS(2322): Type 'Function' is not assignable to type '(...arg... Remove this comment to see the full error message
const FloatingAction = ({
  size = SIZES.large,
  appearance = APPEARANCES.accent,
  iconGlyph = 'plus-for-button',
  position = POSITION.default,
  disabled = false,
  onClick = Function.prototype,
}) => {
  const classes = classNames(
    'ws-ui-floating-action',
    `ws-ui-floating-action--${size}`,
    `ws-ui-floating-action--${appearance}`,
    `ws-ui-floating-action--${position}`,
    { 'ws-ui-floating-action--disabled': disabled }
  );

  return (
    <button className={classes} onClick={onClick}>
      <Icon glyph={iconGlyph} />
    </button>
  );
};

export default FloatingAction;
